import { Box } from '@mui/material';
import { MatxProgressBar, SimpleCard } from 'app/components';
import { Small } from 'app/components/Typography';
import { useSelector } from 'react-redux';

const Campaigns = () => {
	const { booking } = useSelector((state) => state.home);
	return (
		<Box>
			<SimpleCard title={`Latest Flight Booking`}>
				{/* <Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}>
					<Small color='text.secondary'>{booking?.result[0]?.dob}</Small>
					<Small color='text.secondary'>{booking?.result[0]?.travelDate}</Small>
				</Box>
				<Box
					display={'flex'}
					justifyContent={'space-between'}
					alignItems={'center'}>
					<h1>{booking?.result[0]?.origin}</h1>
					<img
						src='https://www.iconbunny.com/media/catalog/product/2/9/2956.3-flight-takeoff-icon-iconbunny.jpg?width=300&height=300&store=icons&image-type=small_image'
						style={{ width: 50, height: 50 }}
					/>
					<h1>{booking?.result[0]?.destination}</h1>
				</Box> */}
				{/* <MatxProgressBar value={75} color='primary' text='Flight (102k)' />
				<MatxProgressBar value={45} color='secondary' text='Hotel (40k)' />
				<MatxProgressBar value={75} color='primary' text='Bus (80k)' /> */}

				{/* <Small color="text.secondary" display="block" pt={4}>
          Yesterday
        </Small>
        <MatxProgressBar value={75} color="primary" text="Google (102k)" />
        <MatxProgressBar value={45} color="secondary" text="Twitter (40k)" />
        <MatxProgressBar value={75} color="primary" text="Tensor (80k)" />

        <Small color="text.secondary" display="block" pt={4}>
          Yesterday
        </Small> */}
				{/* <MatxProgressBar value={75} color='primary' text='Google (102k)' />
				<MatxProgressBar value={45} color='secondary' text='Twitter (40k)' />
				<MatxProgressBar value={75} color='primary' text='Tensor (80k)' /> */}
			</SimpleCard>
		</Box>
	);
};

export default Campaigns;
